import { render, staticRenderFns } from "./MessageMiddleLight.vue?vue&type=template&id=516954d8"
import script from "./MessageMiddleLight.vue?vue&type=script&lang=ts"
export * from "./MessageMiddleLight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports